import React from 'react';
import { Bell, BellRing, X } from 'lucide-react';

export const NotificationPromptBanner = ({ t, onEnable, onDismiss }) => (
  <div
    className="mb-6 p-4 rounded-xl bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-purple-500/30 flex items-center gap-4"
    data-testid="notification-prompt-banner"
  >
    <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center flex-shrink-0">
      <BellRing className="w-5 h-5 text-purple-400" />
    </div>
    <div className="flex-1">
      <h4 className="text-white font-medium text-sm">
        {t('notifications.enableTitle') || 'Enable Desktop Notifications'}
      </h4>
      <p className="text-gray-400 text-xs mt-0.5">
        {t('notifications.enableDescription') || 'Get alerted when calls come in, even when this tab is in the background'}
      </p>
    </div>
    <div className="flex items-center gap-2">
      <button
        onClick={onEnable}
        className="px-4 py-2 bg-purple-500 hover:bg-purple-600 text-white text-sm font-medium rounded-lg transition-colors flex items-center gap-2"
        data-testid="enable-notifications-btn"
      >
        <Bell className="w-4 h-4" />
        {t('notifications.enable') || 'Enable'}
      </button>
      <button
        onClick={onDismiss}
        className="p-2 text-gray-400 hover:text-white rounded-lg hover:bg-gray-800 transition-colors"
        data-testid="dismiss-notifications-btn"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  </div>
);
